import { render, staticRenderFns } from "./Clients1.container.vue?vue&type=template&id=f818d8c6&"
import script from "./Clients1.container.vue?vue&type=script&lang=js&"
export * from "./Clients1.container.vue?vue&type=script&lang=js&"
import style0 from "./Clients1.container.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports